var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"schlagwort-component"}},[_c('div',{style:(_vm.textBackground),attrs:{"id":"schlagwort-text"}},[_vm._v(_vm._s(_vm.schlagwort))]),_c('div',{attrs:{"id":"schlagwort-arrow"}},[(!_vm.isLastSchalgwort)?_c('b-icon-arrow-right',{staticClass:"arrow"}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }